import { yupResolver } from '@hookform/resolvers';
import React, { useContext, useEffect } from 'react';
import { useForm } from "react-hook-form";
import InputMask from 'react-input-mask';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import * as yup from "yup";
import { UserContext } from '../../context/usercontext';
import withApp from '../../higherorder';
import { setDialogData } from '../../redux-store/actions/global.actions';
import CaptchaService from '../../service/captcha.service';
import PdpService from '../../service/pdp.service';
const schema = yup.object().shape({
    customer_name: yup.string().required('Customer Name is required'),
    customer_email: yup.string().email().required('Email id is required'),
    customer_phone: yup.string().required('Phone number is required').matches(/(?:^|\D)\(([0-9])(?:\d(?!\1)\d|(?!\1)\d\d)\)\s*[2-9]\d{2}-\d{4}/,'Phone number is not valid'),
    postal_code: yup.string().required('Zip code is required').matches(/^\d{5}$/,'Zip Code is not valid'),
    business_name : yup.string().required('Business Name is required'),
    type_of_business : yup.number().transform((value) => Number.isNaN(value) ? null : value ).nullable().required('Business type is required'),
    requested_qty:  yup.number().transform((value) => Number.isNaN(value) ? null : value ).nullable().required('Requested quantity is required').min(50,'Requested Quantity should not be lower than 50')
});
const Pallete = ({product_name,sku,id,constant}) => {
    const pdpData= useSelector(state=>state.pdpData);
    const customerGroupData= useSelector(state=>state.customerGroupData,shallowEqual);
    console.log("hello customerGroupData", customerGroupData)
    const userContext = useContext(UserContext);
    const dispatch = useDispatch();
    
    const default_shipping = userContext.isGuestUser ? undefined : userContext.addresses.find(address => address.default_shipping);
    console.log("hello default shipping", default_shipping)
    const { register, handleSubmit, errors , watch } = useForm({
        resolver: yupResolver(schema)
    });
    const selectedBusinessType = watch('type_of_business');

    const selectBusinessType = (selectedValue) => {
        // Handle the selected business type here
        console.log('Selected business type:', selectedValue);
        // You can perform any other actions based on the selected value
      };
    
    useEffect(() => {
        // You can also do something with the selectedBusinessType whenever it changes
        console.log('Selected business type:', selectedBusinessType);
      }, [selectedBusinessType]);

    const onSubmit = (data) =>{
        console.log(default_shipping,'adasd');
        const pdpService = new PdpService({});
        pdpService.addPalatee(data).then(res=>{
            dispatch(setDialogData({props:{
                open:false}}));
        });
    }
    useEffect(() => {
        const captcha = new CaptchaService();
        captcha.includeJs();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    useEffect(()=>{
        if(Object.keys(errors).length)
            openPalletePopup();
    },[errors]); // eslint-disable-line react-hooks/exhaustive-deps
    const openPalletePopup = (e)=>{
        dispatch(setDialogData({props:{
            open:true,
        },
            title:<span>{product_name}-{sku}</span>,
            content:
             <form>
                    <p className="pb-3">Please complete this form to be considered for bulk pricing (minimum of 50 cases; bulk pricing not guaranteed). Our team will respond to you by email within 2 business days</p>
                    <div className="row">
                  
                    <input ref={register} defaultValue={!userContext.isGuestUser ? userContext.firstname + ' ' + userContext.lastname :''}  className="c-text-input mb-3" name="customer_name" placeholder="Customer Name" type="text"></input>
                    {errors.customer_name && <div className="text-danger pb-2">{errors.customer_name.message}</div>}
                   
                    <input ref={register} defaultValue={default_shipping ? default_shipping.company : ''} className="c-text-input mb-3" name="business_name" placeholder="Business Name" type="text"></input>
                    {errors.business_name && <div className="text-danger pb-2">{errors.business_name.message}</div>}
                    <div className="c-product-custom-quote__business-type-select mb-3">
                    <div className="c-selectbox business-type">
                    <select ref={register} name="type_of_business" onChange={(e) => selectBusinessType(e.target.value)}>
                    <option value={null}>Select business type</option> {/* Default option */}
                    {Object.values(customerGroupData?.items).map((item)=>{
                            return <option value={item.id}>{item.code}</option>
                        })}
                    </select>
                    </div>
                    </div>
                    {errors.type_of_business && <div className="text-danger pb-2">{errors.type_of_business.message}</div>}
                    <input ref={register} defaultValue={!userContext.isGuestUser ? userContext.email.toLowerCase() :''} className="c-text-input mb-3" name="customer_email" placeholder="Email" type="text"></input>
                    {errors.customer_email && <div className="text-danger pb-2">{errors.customer_email.message}</div>}
                   
                    </div>
                    <InputMask mask="(999) 999-9999" defaultValue={default_shipping ? default_shipping.telephone : ''}>
                    {(inputProps) => (
                     <input ref={register}  className="c-text-input mb-3" name="customer_phone" placeholder="Phone"  />

                    )}
                    </InputMask>
                    {errors.customer_phone && <div className="text-danger pb-2">{errors.customer_phone.message}</div>}
                    {/* <input ref={register}  onBlur={(e)=>phonemask(e)} defaultValue={default_shipping ? default_shipping.telephone : ''}  className="c-text-input mb-3" name="customer_phone" placeholder="Phone" type="text"></input> */}
                    <input ref={register}  value={product_name}  className="c-text-input" name="product_name"  type="hidden"></input>
                    <input ref={register} value={sku}  className="c-text-input" name="product_sku"  type="hidden"></input>
                 
                    <InputMask mask={"99999"} defaultValue={default_shipping ? default_shipping.postcode : ''}  maskChar=" ">
                    {(inputProps) => (
                    <input  ref={register}  className="c-text-input mb-3" name="postal_code" placeholder="Shipping Zip Code" type="text"></input>
                    
                    )}
                    </InputMask>
                    {errors.postal_code && <div className="text-danger pb-2">{errors.postal_code.message}</div>}
                    <InputMask mask={"99999"}  maskChar=" ">
                        {(inputProps) => (
                            <input ref={register}  className="c-text-input mb-3" name="requested_qty" placeholder="Requested Quantity (min 50 cases)" type="text"></input>
                        )}
                    </InputMask>
                    {errors.requested_qty && <div className="text-danger pb-2">{errors.requested_qty.message}</div>}
                    {/* <input ref={register}  className="c-text-input" name="customer_id"  type="hidden"></input> */}
                    <textarea ref={register}  className="c-textarea mb-3" name="additional_info" placeholder="Additional Information"></textarea>

            </form>,
            submitText:"Submit Request",
            onSubmit:handleSubmit(onSubmit)
        }))
    }
    // {console.log("pdpdata complete ", disable_bulk_pricing_request)}
    return <><div className="d-flex align-items-center my-3">
     {/* <img style={{width:"30px"}} alt="palatte" src={`${constant.imagePath}images/icon/pallet-02.png`} /> */}
     <span className="c-text_request-and-buy-cases">Looking to buy a large amount of cases?</span>
     </div>
     <div><a className='c-text_get_custom_quote' onClick={openPalletePopup} href="#/">Get a Custom Quote</a></div>
     </>
}
export default withApp(Pallete);